import React from 'react'
import { Helmet } from 'react-helmet'

interface Props {
  title?: string
  description?: string
  keywords?: string
  image?: string
  url?: string
  canonicalUrl?: string
  type?: string
  schemaData?: any
  site: {
    title: string
    description: string
    siteUrl: string
    author: string
  }
}

const EnhancedMeta: React.FC<Props> = ({
  title,
  description,
  keywords,
  image,
  url,
  canonicalUrl,
  type = 'website',
  schemaData,
  site,
}) => {
  const siteTitle = site?.title || 'Ada Aesthetics'
  const siteUrl = site?.siteUrl || 'https://adaaesthetics.uk'
  const pageTitle = title ? `${title} | ${siteTitle}` : siteTitle
  const pageDescription = description || site?.description
  const pageImage = image || `${siteUrl}/images/ada-aesthetics-og.jpg`
  const pageUrl = url || siteUrl
  const canonical = canonicalUrl || pageUrl

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* Mobile Optimization */}
      <meta name="format-detection" content="telephone=yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="default" />
      
      {/* Open Graph */}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Ada Aesthetics" />
      <meta property="og:locale" content="en_GB" />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDescription} />
      <meta name="twitter:image" content={pageImage} />
      
      {/* Local SEO */}
      <meta name="geo.region" content="GB-HRT" />
      <meta name="geo.placename" content="Cheshunt, Hertfordshire" />
      <meta name="geo.position" content="51.7024;-0.0347" />
      <meta name="ICBM" content="51.7024, -0.0347" />
      
      {/* Business Information */}
      <meta name="contact:phone_number" content="07478705252" />
      <meta name="contact:email" content="info@adaaesthetics.uk" />
      <meta name="contact:address" content="15 Ousden Drive, Cheshunt, EN8 9RL" />
      
      {/* Schema.org JSON-LD */}
      {schemaData && (
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      )}
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonical} />
    </Helmet>
  )
}

export default EnhancedMeta
